import { render, staticRenderFns } from "./yc-cost-details.vue?vue&type=template&id=5c61d5da&scoped=true&"
import script from "./yc-cost-details.vue?vue&type=script&lang=js&"
export * from "./yc-cost-details.vue?vue&type=script&lang=js&"
import style0 from "./yc-cost-details.vue?vue&type=style&index=0&id=5c61d5da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c61d5da",
  null
  
)

export default component.exports